import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const LoginGroupForm = function LoginGroupForm(props) {
    const { children } = props;
    return (
        <div className={styles['login-group-form']}>
            {children}
        </div>
    );
};

LoginGroupForm.propTypes = {
    children: PropTypes.node.isRequired,
};

export default LoginGroupForm;
